import { styled as t } from "@lokalise/styled";
import { spacing as o } from "../../utils/theme/index.js";
const i = t.div`
	margin-top: ${o(4)};
`, m = t.div`
	margin: ${o(4)};
`;
export {
  i as ButtonWrap,
  m as DrawerContent
};
//# sourceMappingURL=styles.js.map
